import { getErrorCode, getErrorResponse, getErrorText } from '../../../../../common/api/errors'

interface RequisiteConflict {
  conflictingRequisiteId?: number | string
  conflictingRequisiteName?: string
  conflictingCashBoxTitle?: string
  conflictingRequisiteOutOfScope?: boolean
}

const CONFLICT_TEXT: Record<string, string> = {
  REQUISITE_CARD_NUMBER_TAKEN: 'Этот номер карты уже у включённого реквизита',
  REQUISITE_CARD_LAST_DIGITS_TAKEN: 'Последние цифры карты совпадают с включённым реквизитом',
}

const TOGGLE_FAILED_TEXT = 'Не удалось изменить активность реквизита'

/** Текст отказа «Включить/выключить реквизит»: конфликт карты называет реквизит, с которым он случился. */
export const requisiteToggleErrorText = (error: unknown): string => {
  const code = getErrorCode(error)
  const base = code ? CONFLICT_TEXT[code] : undefined

  if (!base) {
    return getErrorText(error, TOGGLE_FAILED_TEXT, { withFieldName: false })
  }

  const conflict = getErrorResponse<RequisiteConflict>(error) ?? {}
  if (conflict.conflictingRequisiteId === undefined) {
    return base
  }
  if (conflict.conflictingRequisiteOutOfScope) {
    return `${base}: реквизит #${conflict.conflictingRequisiteId} вне вашего доступа`
  }

  const name = conflict.conflictingRequisiteName ? ` «${conflict.conflictingRequisiteName}»` : ''
  const cashBox = conflict.conflictingCashBoxTitle ? `, касса «${conflict.conflictingCashBoxTitle}»` : ''

  return `${base}: реквизит #${conflict.conflictingRequisiteId}${name}${cashBox}`
}
